import { render, staticRenderFns } from "./BonusEdit.vue?vue&type=template&id=0d33c959"
import script from "./BonusEdit.vue?vue&type=script&lang=js"
export * from "./BonusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports